import React from 'react';

import PriceSpan from 'common/components/formatters/PriceSpan';
import { TranslatedMessage } from 'common/components/Intl';
import { number, string, bool } from 'prop-types';

const LineItemPrice = ({
  discountContentKey,
  originalPrice,
  price,
  strikethrough,
}) => {
  const originalPriceDisplay = () => {
    if (!originalPrice) {
      return null;
    }

    return strikethrough ? (
      <PriceSpan
        amount={originalPrice}
        className="line-item__discount-price subheading--small line-item__discount-price--strikethrough"
      />
    ) : (
      <TranslatedMessage
        className="line-item__discount-price subheading--small"
        id={`${discountContentKey}.original_price`}
        values={{
          price: <PriceSpan amount={originalPrice} />,
        }}
      />
    );
  };

  const priceDisplay = () => {
    return !originalPrice || (originalPrice && strikethrough) ? (
      <PriceSpan amount={price} className="line-item__price heading--small" />
    ) : (
      <TranslatedMessage
        className="line-item__price heading--small"
        id={`${discountContentKey}.discount_price`}
        values={{
          price: <PriceSpan amount={price} />,
        }}
      />
    );
  };

  return (
    <>
      {originalPriceDisplay()}
      {priceDisplay()}
    </>
  );
};

LineItemPrice.propTypes = {
  discountContentKey: string,
  originalPrice: number,
  price: number.isRequired,
  strikethrough: bool.isRequired,
};

export default LineItemPrice;
